<template>
  <article class="group flex w-full" data-component="CardOverview">
    <a :href="url" class="flex w-full bg-white">
      <figure class="figure shrink-0 rounded-xl overflow-hidden">
        <MoleculePicture :fallback="true" class="v-hover-zoom-image w-full h-full object-cover transform transition duration-200" :image="image" :alt="imgAlt" />
      </figure>
      <section class="relative flex flex-1 flex-col pl-4 leading-tight">
        <div class="flex-auto pr-12 py-4 border-b-2 border-solid border-app-green">
          <p v-if="type" class="mb-1 text-xs uppercase">{{ type }}</p>
          <h3 class="text-sm font-bold">{{ title }}</h3>
          <AtomIconArrowRight class="absolute bottom-0 right-0 mb-4 mr-4 w-3 h-3 text-app-green transform group-hover:translate-x-1 transition duration-200 sm:w-4 sm:h-4" />
        </div>
      </section>
    </a>
  </article>
</template>

<script setup lang="ts">
interface Props {
  url: string
  title: string
  type?: string
  image?: object
  imgAlt?: string
}

defineProps<Props>()
</script>

<style lang="scss" scoped>
.figure {
  width: 126px;
  height: 100px;
}
</style>
